module.exports = __webpack_public_path__ + "static/media/ic_收起2.40a73ea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_收起2.svg
// module id = 342
// module chunks = 0